import { render, staticRenderFns } from "./DetailsImageItem.vue?vue&type=template&id=3788a572"
import script from "./DetailsImageItem.vue?vue&type=script&lang=js"
export * from "./DetailsImageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports